module.exports = __webpack_public_path__ + "static/media/image-4.240b1b01.png";